import * as React from "react";

export const MagazineContext = React.createContext('magazine');
